// src/components/ChatPdfDocument.js (or within UserChatHistory.js)
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';



// Create styles for the PDF
const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    fontFamily: 'Helvetica', // Default font
  },
  header: {
    fontSize: 24,
    textAlign: 'center',
    marginBottom: 20,
    fontWeight: 'bold',
    color: '#2d69c5',
  },
  subheader: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 30,
    fontWeight: 'bold',
    color: '#666666',
  },
  section: {
    marginBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#EEEEEE',
    paddingBottom: 10,
  },
  messageHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#333333',
  },
  systemText: {
    fontSize: 10,
    fontStyle: 'italic',
    marginBottom: 2,
    color: '#555555',
  },
  userText: {
    fontSize: 10,
    marginBottom: 8,
    color: '#000000',
  },
  noConversation: {
    fontSize: 12,
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: 20,
    color: '#888888',
  },
});

const ChatPdfDocument = ({ chat, userName }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>
      <Text style={pdfStyles.header}>User Chat History</Text>
      <Text style={pdfStyles.subheader}>User: {userName || 'N/A'}</Text>
      <Text style={pdfStyles.subheader}>Session ID: {chat.sessionId}</Text>

      {chat.conversation && chat.conversation.length > 0 ? (
        chat.conversation.map((msg, index) => (
          <View key={msg._id || index} style={pdfStyles.section}>
            <Text style={pdfStyles.messageHeader}>Message {index + 1}:</Text>
            <Text style={pdfStyles.systemText}>System: {msg.system}</Text>
            <Text style={pdfStyles.userText}>User: {msg.user}</Text>
          </View>
        ))
      ) : (
        <Text style={pdfStyles.noConversation}>No conversation recorded for this session.</Text>
      )}
    </Page>
  </Document>
);

export default ChatPdfDocument;